<template>
    <div class="d-flex justify-content-center">
        <button type="button" class="btn btn-secondary" @click="initiateOAuth">
            Autentisera med {{ provider }}
        </button>
    </div>
</template>

<style scoped lang="scss"></style>

<script setup lang="ts">
import { ref, toRefs } from "vue";
const props = defineProps({
  provider: {
    type: String,
    default: "Fortnox"
  },
  initiator: {
    type: String,
    required: true
  }
});
const {
  provider,
  initiator
} = toRefs(props);
const emit = defineEmits(["success", "failure"]);
const interval = ref(null);
const statusCheckUrl = ref(null);
async function initiateOAuth() {
  const response = await axios.post(initiator.value);
  statusCheckUrl.value = response.data.statusCheckUrl;
  window.open(response.data.redirectUrl, "myWindow", "width=800,height=600");
  interval.value = null;
  interval.value = setInterval(async () => {
    try {
      const response = await axios.get(statusCheckUrl.value);
      if (response.data.status === "Pending" || response.data.status === "Unset") {
        return;
      }
      if (response.data.status === "Done") {
        emit("success", response.data.tokens);
      } else {
        emit("failure");
      }
      clearInterval(interval.value);
    } catch (e) {
      console.log(e);
      clearInterval(interval.value);
    }
  }, 1000);
}
</script>
